// @flow

import { onlyNumbers } from '@tectonics/prs/normalize';
import { type ColombianDocumentType } from './types';

export function normalizeDocument(documentType: ColombianDocumentType, document: ?string): string {
  const normalized = document ? onlyNumbers(document) : '';
  return documentType === 'CE'
    ? normalized.substr(0, 7)
    : normalized;
}
